import { Button } from "antd"
import { isNullOrUndefined, isNullOrUndefinedOrEmptyOrMissing } from "../community-hats-js-library/utils/generalFunctions"
import { downloadZip } from "../community-hats-js-library/utils/labFunctions"
import * as libCon from "../community-hats-js-library/Constants.js"


export function DownloadFilesButton({ pdfFiles, metadataForFiles, keys, fileName }) {

    const processZip = () => {

        if (!isNullOrUndefinedOrEmptyOrMissing(keys) && !isNullOrUndefined(pdfFiles) & !isNullOrUndefined(metadataForFiles)) {
            let pdfs = keys.map(k => pdfFiles[k])
            let filenames = keys.map(k => metadataForFiles[k][libCon.ATF_FILE_NAME])
            downloadZip(pdfs, filenames, fileName)

        }

    }

    return (
        <Button key="submit" type="primary" onClick={processZip}>
            Download Files
        </Button>
    )


}